import { css } from 'styled-components'

export const Noto_DisPlay1_b40 = css`
  font-size: 40px;
  line-height: 64px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`

export const Noto_DisPlay2_b32 = css`
  font-size: 32px;
  line-height: 48px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`

export const Noto_heading1_b28 = css`
  font-size: 28px;
  line-height: 48px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`
export const Noto_heading3_b26 = css`
  font-size: 26px;
  line-height: 40px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`

export const Noto_DisPlay2_b24 = css`
  font-size: 24px;
  line-height: 40px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`
export const Noto_heading2_r24 = css`
  font-size: 24px;
  line-height: 40px;
  font-weight: 400;
  font-family: NotoSansRegular, sans-serif;
`
export const Noto_heading3_b20 = css`
  font-size: 20px;
  line-height: 32px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`

export const Noto_heading3_r20 = css`
  font-size: 20px;
  line-height: 32px;
  font-weight: 400;
  font-family: NotoSansRegular, sans-serif;
`

export const Noto_subheading_b18 = css`
  font-size: 18px;
  line-height: 32px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`

export const Noto_subheading_m18 = css`
  font-size: 18px;
  line-height: 32px;
  font-weight: 500;
  font-family: NotoSansMedium, sans-serif;
`

export const Noto_subheading_r18 = css`
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
  font-family: NotoSansRegular, sans-serif;
`

export const Noto_body1_b16 = css`
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`

export const Noto_body1_m16 = css`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  font-family: NotoSansMedium, sans-serif;
`

export const Noto_body1_r16 = css`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  font-family: NotoSansRegular, sans-serif;
`
export const Noto_body2_b15 = css`
  font-size: 15px;
  line-height: 24px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`
export const Noto_body2_m15 = css`
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
  font-family: NotoSansMedium, sans-serif;
`
export const Noto_body2_r15 = css`
  font-size: 15px;
  line-height: 24px;
  font-weight: 400;
  font-family: NotoSansRegular, sans-serif;
`
export const Noto_body2_b14 = css`
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`
export const Noto_body2_m14 = css`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  font-family: NotoSansMedium, sans-serif;
`
export const Noto_body2_r14 = css`
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  font-family: NotoSansRegular, sans-serif;
`

export const Noto_body3_b12 = css`
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`

export const Noto_body3_m12 = css`
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  font-family: NotoSansMedium, sans-serif;
`

export const Noto_body3_r12 = css`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  font-family: NotoSansRegular, sans-serif;
`

export const Noto_desc_b10 = css`
  font-size: 10px;
  line-height: 16px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`

export const Noto_desc_m10 = css`
  font-size: 10px;
  line-height: 16px;
  font-weight: 500;
  font-family: NotoSansMedium, sans-serif;
`
export const Noto_desc_r10 = css`
  font-size: 10px;
  line-height: 16px;
  font-weight: 400;
  font-family: NotoSansRegular, sans-serif;
`

export const Noto_desc_b8 = css`
  font-size: 8px;
  line-height: 12px;
  font-weight: 700;
  font-family: NotoSansBold, sans-serif;
`
export const Noto_desc_m8 = css`
  font-size: 8px;
  line-height: 12px;
  font-weight: 500;
  font-family: NotoSansMedium, sans-serif;
`
export const Noto_desc_r8 = css`
  font-size: 8px;
  line-height: 12px;
  font-weight: 400;
  font-family: NotoSansRegular, sans-serif;
`
